import { Plugin } from "@ckeditor/ckeditor5-core";
import { ButtonView } from "@ckeditor/ckeditor5-ui";

import "./CBTPBT.css";

export default class CBTPBTUI extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;

    editor.ui.componentFactory.add("applyCBT", (locale) => {
      const command = editor.commands.get("applyCBTPBT");
      const cbtButtonView = new ButtonView();

      cbtButtonView.set({
        isToggleable: true,
        label: t("CBT"),
        withText: true,
        tooltip: "Computer Based Test",
      });

      cbtButtonView
        .bind("isOn", "isEnabled")
        .to(command, "isCBTOn", "isEnabled");
      cbtButtonView.on("execute", (e) => {
        command.execute("cbt");
        editor.editing.view.focus();
      });
      return cbtButtonView;
    });

    editor.ui.componentFactory.add("applyPBT", (locale) => {
      const command = editor.commands.get("applyCBTPBT");
      const pbtButtonView = new ButtonView();

      pbtButtonView.set({
        isToggleable: true,
        label: t("PBT"),
        withText: true,
        tooltip: "Paper Based Test",
      });

      pbtButtonView
        .bind("isOn", "isEnabled")
        .to(command, "isPBTOn", "isEnabled");
      pbtButtonView.on("execute", (e) => {
        command.execute("pbt");
        editor.editing.view.focus();
      });
      return pbtButtonView;
    });
  }
}
